import { useEffect, useState } from 'react';
import api from '../services/api';
import type { CommunityLink } from './useApi';

// Herkese açık WhatsApp topluluk bağlantıları. Navbar butonu, anasayfa bölümü
// ve giriş yapan kullanıcıya gösterilen pop-up aynı veriyi kullandığından
// modül seviyesinde küçük bir önbellek tutuyoruz (tek istek).
let cache: CommunityLink[] | null = null;
let inflight: Promise<CommunityLink[]> | null = null;

async function fetchLinks(): Promise<CommunityLink[]> {
  if (cache) return cache;
  if (!inflight) {
    inflight = api
      .getSiteSettings()
      .then((res: any) => {
        const links: CommunityLink[] =
          (res?.success && res?.data?.settings?.whatsappLinks) || [];
        cache = links;
        return links;
      })
      .catch(() => [] as CommunityLink[])
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

/** Önbelleği temizler (örn. admin panelinden kayıt sonrası tazeleme için). */
export function invalidateCommunityLinks() {
  cache = null;
  inflight = null;
}

export function useCommunityLinks() {
  const [links, setLinks] = useState<CommunityLink[]>(cache || []);
  const [loading, setLoading] = useState<boolean>(!cache);

  useEffect(() => {
    let active = true;
    if (cache) {
      setLinks(cache);
      setLoading(false);
      return;
    }
    setLoading(true);
    fetchLinks().then((l) => {
      if (active) {
        setLinks(l);
        setLoading(false);
      }
    });
    return () => {
      active = false;
    };
  }, []);

  return { links, loading };
}
